import React, { useState } from "react";
import styles from "./AccessManagement.module.css";
import axios from "axios";
import commonStyles from '../../common/CommonStyles.module.css';

const AccessManagement = () => {
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [actionMessage, setActionMessage] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setActionMessage("");
    try {
      const response = await axios.get(`/api/users/search?query=${encodeURIComponent(search)}`);
      setUsers(response.data.content || []);
      setSelectedUser(null);
    } catch (err) {
      setError("Ошибка при поиске пользователей");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setActionMessage("");
  };

  const hasAdminRole = (user) => {
    return user.roles && user.roles.some((role) => role.name === "ROLE_ADMIN");
  };

  const handleGrantAdmin = async () => {
    if (!selectedUser) return;
    setLoading(true);
    setError("");
    setActionMessage("");
    try {
      await axios.post(`/api/users/access/grant-admin`, { id: selectedUser.id });
      setActionMessage("Права администратора назначены");
      setSelectedUser({
        ...selectedUser,
        roles: [...selectedUser.roles, { name: "ROLE_ADMIN" }],
      });
    } catch (err) {
      setError("Ошибка при назначении роли администратора");
    } finally {
      setLoading(false);
    }
  };

  const handleRevokeAdmin = async () => {
    if (!selectedUser) return;
    setLoading(true);
    setError("");
    setActionMessage("");
    try {
      await axios.post(`/api/users/access/revoke-admin`, { id: selectedUser.id });
      setActionMessage("Права администратора сняты");
      setSelectedUser({
        ...selectedUser,
        roles: selectedUser.roles.filter((role) => role.name !== "ROLE_ADMIN"),
      });
    } catch (err) {
      setError("Ошибка при снятии роли администратора");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={commonStyles.pageContainer}>
      <div className={commonStyles.contentContainer}>
        <div className={commonStyles.content}>
          <h2 style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>
            Управление доступами
          </h2>
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <input
              type="text"
              placeholder="Поиск по ФИО..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ flex: 1, padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
            />
            <button type="submit" disabled={loading} style={{ backgroundColor: '#2196F3', color: 'white', borderRadius: 4, fontWeight: 500, padding: '0.8rem 1.5rem', fontSize: '1rem' }}>
              Найти
            </button>
          </form>
          {error && <div style={{ color: '#dc2626', margin: '10px 0' }}>{error}</div>}
          {users.length > 0 && (
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 16px 0', border: '1px solid #eee', borderRadius: 6, background: '#fafbfc' }}>
              {users.map((user) => (
                <li
                  key={user.id}
                  style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #eee', transition: 'background 0.15s' }}
                  onClick={() => handleSelectUser(user)}
                >
                  {user.lastName} {user.firstName} {user.patronymic} ({user.email})
                </li>
              ))}
            </ul>
          )}
          {selectedUser && (
            <div style={{ marginTop: 20, padding: '18px 16px', border: '1px solid #e5e7eb', borderRadius: 8, background: '#f9fafb' }}>
              <h3>
                {selectedUser.lastName} {selectedUser.firstName} {selectedUser.patronymic}
              </h3>
              <p>Email: {selectedUser.email}</p>
              <p>Телефон: {selectedUser.phoneNumber}</p>
              <p>Роли: {selectedUser.roles.map((r) => r.name).join(", ")}</p>
              {hasAdminRole(selectedUser) ? (
                <button onClick={handleRevokeAdmin} disabled={loading} style={{ marginTop: 12, padding: '8px 18px', background: '#ff4444', color: '#fff', border: 'none', borderRadius: 6, fontSize: 16, cursor: 'pointer', transition: 'background 0.2s' }}>
                  Разжаловать администратора
                </button>
              ) : (
                <button onClick={handleGrantAdmin} disabled={loading} style={{ marginTop: 12, padding: '8px 18px', background: '#059669', color: '#fff', border: 'none', borderRadius: 6, fontSize: 16, cursor: 'pointer', transition: 'background 0.2s' }}>
                  Назначить администратором
                </button>
              )}
              {actionMessage && <div style={{ color: '#059669', margin: '10px 0' }}>{actionMessage}</div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccessManagement; 